<template>
  <div class="row">
    <div class="col-12 col-md-8">
      <div class="modal-text">

        <article class="reason">
          <h3>{{ $t('more_info.reasons') }}</h3>
          <ul class="list list-unstyled">
            <li v-for="(point, key) in moreInfo.intro_marketing" :key="key">
             <span v-if="point.length > 0">
                <i class="icon-check_circle"></i>
                {{ point }}
              </span>
            </li>
          </ul>
        </article>

        <article class="reason">
          <h3>{{ $t('more_info.overview') }}</h3>
          <p v-html="moreInfo.intro"></p>
        </article>

        <div class="quote-block" v-if="moreInfo.reevoo_latest">
          <h3>{{ $t('more_info.latest_review') }}</h3>
          <blockquote class="review">
            <q>{{ moreInfo.reevoo_latest.general_comments }}</q>
            <cite>
              <span class="name" v-if="moreInfo.reevoo_latest.reviewer">{{ moreInfo.reevoo_latest.reviewer.first_name.toLowerCase() }} - </span>
              <span class="text-success">{{ moreInfo.reevoo_latest.overall_score }} {{ $t('more_info.out_of')}} 10</span>
              <time :datetime="moreInfo.reevoo_latest.sort_and_display_date">
                {{ formatDate(moreInfo.reevoo_latest.sort_and_display_date, 'Do MMMM YYYY') }}
              </time>
            </cite>
          </blockquote>
        </div>

      </div>
    </div>
    <div class="col-12 col-md-4">
      <right-col />
    </div>
  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import mixins from "@/mixins";
import { RightCol } from "@/components";

export default {
  name: "SummaryTab",
  mixins: [mixins.format],
  components: { RightCol },
  computed: {
    moreInfo: sync("modals/moreInfo")
  }
};
</script>